module.exports = __webpack_public_path__ + "static/media/ng.9bd45b32.svg";